<template>
  <div class="listing-edit-box">
    <div class="main-container">
      <h2 class="">リスティング詳細</h2>

      <div class="list-box">
        <div class="list-box-item">
          <p class="list-title">部屋番号(部屋名)</p>
          <p class="list-content"><input class="" type="text" v-model="listing.name"></p>
        </div>
        <div class="list-box-item">
          <p class="list-title">住所(英語)</p>
          <p class="list-content"><textarea v-model="listing.address_en" rows="4"></textarea></p>
        </div>
        <div class="list-box-item">
          <p class="list-title">住所(日本語)</p>
          <p class="list-content"><textarea v-model="listing.address_ja" rows="4"></textarea></p>
        </div>
        <div class="list-box-item">
          <p class="list-title">経路(英語)</p>
          <p class="list-content"><textarea v-model="listing.route_en" rows="4"></textarea></p>
        </div>
        <div class="list-box-item">
          <p class="list-title">経路(日本語)</p>
          <p class="list-content"><textarea v-model="listing.route_ja" rows="4"></textarea></p>
        </div>
        <div class="list-box-item">
          <p class="list-title">エントランス(英語)</p>
          <p class="list-content"><textarea v-model="listing.entrance_en" rows="4"></textarea></p>
        </div>
        <div class="list-box-item">
          <p class="list-title">エントランス(日本語)</p>
          <p class="list-content"><textarea v-model="listing.entrance_ja" rows="4"></textarea></p>
        </div>
        <div class="list-box-item">
          <p class="list-title">カギ情報(英語)</p>
          <p class="list-content"><input class="" type="text" v-model="listing.key_url_en"></p>
        </div>
        <div class="list-box-item">
          <p class="list-title">カギ情報(日本語)</p>
          <p class="list-content"><input class="" type="text" v-model="listing.key_url_ja"></p>
        </div>
        <div class="list-box-item">
          <p class="list-title">宅配ボックス(英語)</p>
          <p class="list-content"><textarea class="" v-model="listing.delivery_box_en" rows="4"></textarea></p>
        </div>
        <div class="list-box-item">
          <p class="list-title">宅配ボックス(日本語)</p>
          <p class="list-content"><textarea class="" v-model="listing.delivery_box_ja" rows="4"></textarea></p>
        </div>
        <div class="list-box-item">
          <p class="list-title">WIFI</p>
          <p class="list-content"><input class="" type="text" v-model="listing.wifi"></p>
        </div>
        <div class="list-box-item">
          <p class="list-title">Poket WIFI</p>
          <p class="list-content"><input class="" type="text" v-model="listing.pocket_wifi"></p>
        </div>

      </div>

      <input type="button" class="new-add" @click="new_add" v-if="mode == 'add'" value="登録" />
      <div class="flex" v-else >
        <input type="button" class="new-add new-add-s" @click="back_list" value="戻る" />
        <input type="button" class="new-add new-add-s" @click="new_add" value="登録" />
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'ListingEdit',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      listing: {},
      mode: 'add',
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    if (this.$store.getters['loginInfo/owner_info_defect_flag'] !== false) {
      this.$alert('alert', 'オーナー情報を設定してください。');
      this.$router.push({name: 'owner', params: {}});
    }
    if (this.$route.params.mode) {
      this.mode = this.$route.params.mode;
    }
    if (this.mode === 'edit') {
      this.data_get();
    }
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    data_get () {
      let ld = new this.$loader(this);
      ld._data_set({id: this.$route.params.list.id});
      ld._post_cb_f = this.data_get_cb;
      ld._load_start('listing_info_get.php');
    },
    data_get_cb (data) {
      this.listing = data.data;
    },
    date_chk (date) {
      const today = this.$lib._date_text_get(new Date());
      const d = this.$lib._date_text_get(date);
      if (this.$lib._pint(d) < this.$lib._pint(today)) {
        return true;
      }
    },
    new_add () {
      if (this.$lib._emptyChk(this.listing.name) === false) {
        this.$alert('alert', '部屋番号(部屋名)を入力してください。');
        return;
      }

      if (this.mode === 'add') {
        let ld = new this.$loader(this);
        ld._data_set({listing_info: this.listing});
        ld._post_cb_f = this.new_add_cb;
        ld._load_start('listing_info_add.php');
      } else {
        let ld = new this.$loader(this);
        ld._data_set({listing_info: this.listing});
        ld._post_cb_f = this.listing_edit_cb;
        ld._load_start('listing_info_edit.php');
      }
    },
    new_add_cb () {
      this.back_list();
    },
    listing_edit_cb () {
      this.back_list();
    },
    back_list () {
      this.$router.push({name: 'listing_list', params: {}});
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.listing-edit-box {
  text-align: left;

  .main-container {
    .new-add {
      color: #fefefe;
      display: block;
      text-align: center;
      padding: 8px 8px 8px 8px;
      font-size: 16px;
      margin: 50px auto 20px auto;
      text-decoration: none;
      border-radius: 3px;
      width: 150px;
    }
    .new-add-s {
      width: 150px;
    }

    .list-box {
      .list-box-item {
        display: flex;
        .list-title {
          width: 200px;
          background: #fbfbfb;
          color: #24273b;
          text-align: right;
          box-sizing: border-box;
          padding: 10px 15px 10px 8px;

          border-top: 1px solid #d3d4d8;
          border-left: 1px solid #d3d4d8;
          border-right: 1px solid #d3d4d8;
        }
        .list-content {
          flex: 1;
          background: #fbfbfb;
          border-top: 1px solid #d3d4d8;
          border-right: 1px solid #d3d4d8;
          padding: 8px;

          box-sizing: border-box;
        }
      }
      .list-box-item:last-child {
        border-bottom: 1px solid #d3d4d8;
      }
    }
  }
  @media (max-width: 767px) {
    .main-container {
      .list-box {
        .list-box-item {
          display: block;
          .list-title {
            width: 100%;
            text-align: left;
          }
          .list-content {
            border-left: 1px solid #d3d4d8;
          }
        }
      }
    }
  }
}
</style>
